import { useEffect, useRef, useState } from 'react';
import './MessageList.css';

export default function MessageList({ messages, busy, onAcceptAction }) {
    const endRef = useRef(null);

    useEffect(() => {
        endRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, busy]);

    return (
        <div className="messages">
            {messages.map((msg, i) => (
                <div key={i}>
                    <div className={`msg-row ${msg.role}`}>
                        {msg.role === 'assistant' && (
                            <div className="msg-role">INTENSION</div>
                        )}
                        {msg.images && msg.images.length > 0 && (
                            <div className="msg-images">
                                {msg.images.map((img, j) => (
                                    <img key={j} src={img.preview} alt="" className="msg-image" />
                                ))}
                            </div>
                        )}
                        {msg.contextUpdate && (
                            <div className="context-ping">Profile updated</div>
                        )}
                        {msg.fieldReportLogged && (
                            <div className="context-ping">Interaction logged</div>
                        )}
                        {msg.proposedAction && (
                            <ActionCard
                                text={msg.proposedAction}
                                estimatedMinutes={msg.estimatedMinutes}
                                onAccept={onAcceptAction}
                            />
                        )}
                        {msg.content && (
                            <div className={`msg ${msg.role === 'error' ? 'error' : ''}`}>
                                {msg.content}
                            </div>
                        )}
                    </div>
                </div>
            ))}
            {busy && (
                <div className="msg-row assistant">
                    <div className="msg-role">INTENSION</div>
                    <div className="msg typing">Thinking...</div>
                </div>
            )}
            <div ref={endRef} />
        </div>
    );
}

function ActionCard({ text, estimatedMinutes, onAccept }) {
    const [accepted, setAccepted] = useState(false);

    const handleAccept = async () => {
        if (accepted) return;
        const success = await onAccept?.(text, estimatedMinutes);
        if (success) setAccepted(true);
    };

    return (
        <div className="action-card">
            <div className="action-card-label">Suggested action</div>
            <div className="action-card-text">{text}</div>
            {estimatedMinutes && (
                <div className="action-card-time">
                    {estimatedMinutes < 60
                        ? `~${estimatedMinutes} min`
                        : `~${Math.floor(estimatedMinutes / 60)}h${estimatedMinutes % 60 ? ` ${estimatedMinutes % 60}m` : ''}`
                    }
                </div>
            )}
            {accepted ? (
                <div className="action-card-accepted">Added to your actions</div>
            ) : (
                <button className="action-card-btn" onClick={handleAccept}>
                    Accept challenge
                </button>
            )}
        </div>
    );
}
